<template>
    <section class="fac-modal-message" :class="statusClass">
        <section class="overlay"/>
        <section class="content">
            <section v-if="load" class="box radius">
                <ui-load-indicator v-if="!success" bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8"/>
                <span :class="successClass" class="success-icon">
                    <i class="fal fa-check-circle"/>
                </span>
            </section>
            <section v-if="error" class="box">
                <div class="icon">
                    <span class="danger">
                        <i class="fal fa-times"/>
                    </span>
                </div>
                <div class="texts">
                    <div class="title">{{data.errorTitle}}</div>
                    <div class="text">{{data.errorText}}</div>
                </div>
                <div class="actions">
                    <ui-button design="md primary" @click="close"> Fechar </ui-button>
                </div>
            </section>
            <section v-if="!load && !error" class="box">
                <div v-if="icon" class="icon">
                    <span :class="color"><i :class="icon"/></span>
                </div>
                <div class="texts">
                    <div class="title">{{title}}</div>
                    <div class="text" v-html="text" />
                </div>
                <div class="actions">
                    <ui-button design="md line-primary mw-100" @click="close"> Ok </ui-button>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	export default {
		name: 'ui-alert',
		components: { uiButton, uiLoadIndicator },
		props:{
			name: {
				type: String,
				required: true
			},
			title: {
				type: String,
				required: true
			},
			text: {
				type: String,
				required: true
			},
			icon: {
				type: String,
				required: false
			},
			color: {
				type: String,
			},
			btnType: {
				type: String,
				default: 'success'
			},
			btnText: {
				type: String,
				default: 'Confirmar'
			},
			service: {
				type: String,
				required: false,
			}
		},
        data() {
            return {
				data: {
					formdata: {},
					errorTitle: 'Ação não concluída',
				},
				status: false,
				load: false,
				success: false,
				error: false,
				api: null,
            }
		},
		computed:{
			statusClass(){
				return this.status ? 'active' : ''
			},
			successClass(){
				return this.success ? 'active' : ''
			},
			loadService() {
                return () => import('@/services/axios/modules/'+ this.service + '.js')
            },
		},
		watch: {
			data(newData){
				this.data = newData				
			}
		},
		created(){
			this.$root.$on("alert-msg-open-"+this.name, () => {
				this.open()
			})
			this.$root.$on("modal-msg-close-"+this.name, () => {
				this.close()
			})
		},
		mounted() {
			if (this.service) {
				this.loadService().then(async response => {
					this.api = response.default.build()
				})	
			}
        },
		beforeDestroy() {
			this.$root.$off("modal-msg-close-" + this.name)
			this.$root.$off("alert-msg-open-" + this.name)
		},
		methods: {
			
			close(){
				this.status = false
				this.error = false
				
				if(this.data.eventClose) {
					this.$root.$emit(this.data.eventClose)
				}
			},

			open(){
				this.status = true
			},

			eventSuccess(data = null){
				this.$root.$emit(this.data.eventSuccess, data)
			}
		},
		
    };
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>